import { Button, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useState } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import type { ClientUserGroupMember } from "../../../../api/types/userManagementTypes";
import MultiselectAutocomplete from "../../../common/MultiselectAutocomplete";

interface Props {
  memberOptions: ClientUserGroupMember[];
  onClose: () => void;
  onAdd: (members: ClientUserGroupMember[]) => void;
}

const AddUserGroupMembersDialog = ({ memberOptions, onClose, onAdd }: Props) => {
  const [selectedMembers, setSelectedMembers] = useState<ClientUserGroupMember[]>([]);

  const handleAdd = () => {
    onAdd(selectedMembers);
    onClose();
  };

  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Add Members</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent sx={{ height: "36rem" }}>
        <Typography color="textSecondary" sx={{ mb: 2 }}>
          Select one or more existing members
        </Typography>

        <MultiselectAutocomplete
          options={memberOptions}
          values={selectedMembers}
          onSelected={setSelectedMembers}
          getOptionLabel={(o) => o.name}
          getOptionValue={(o) => o.id}
          getOptionDescription={(o) => o.email}
          getOptionSecondaryText={(o) => (o.hasAccessToAllClients ? "All companies" : `${o.access.length} companies`)}
          placeholder="Members"
          dense
        />
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" onClick={handleAdd} disabled={selectedMembers.length === 0}>
          Add
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default AddUserGroupMembersDialog;
